if (!customElements.get('ff-popup')) {
  class FFPopup extends HTMLElement {
    connectedCallback() {
      this.popupId = this.id;

      this.querySelector('[data-ff-popup-close]')?.addEventListener('click', () => this.close());

      this.querySelector('[data-ff-popup-backdrop]')?.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (this.hasAttribute('open') && e.key === 'Escape') this.close();
      });

      document.addEventListener('ff-popup:open', (e) => {
        if (e.detail.popupId === this.popupId) this.open();
      });
    }

    open() {
      if (this.hasAttribute('open')) return;
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    close() {
      if (!this.hasAttribute('open')) return;
      // Locked popups can only be dismissed by their own action (e.g. CTA link).
      if (this.hasAttribute('locked')) return;
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }
  }
  customElements.define('ff-popup', FFPopup);
}

/* Trigger buttons: any [data-ff-popup-trigger] dispatches the open event */
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-ff-popup-trigger]');
  if (!trigger) return;
  const popupId = trigger.dataset.ffPopupTrigger;
  document.dispatchEvent(new CustomEvent('ff-popup:open', {
    detail: { popupId }
  }));
});
